import { ResetFilter } from './reset-filter';

export default ResetFilter;
